import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import { RouterLink } from 'src/routes/components';

import Iconify from 'src/components/iconify';

import { notificationActionTarget } from './notification-action-target';

// ----------------------------------------------------------------------

/**
 * A notification's button, under the bell and on the live pop-up. A Voolist page opens in place; a marketplace
 * post opens in a new tab. Nothing is shown for a notification without a button.
 */
export default function NotificationActionButton ({ action, onClick, sx }) {
  const target = notificationActionTarget(action);
  if (!target) return null;

  const link = target.external
    ? { component: 'a', href: target.href, target: '_blank', rel: 'noopener noreferrer' }
    : { component: RouterLink, href: target.href };

  return (
    <Button
      {...link}
      size="small"
      variant="soft"
      color="inherit"
      onClick={onClick}
      endIcon={target.external ? <Iconify icon="eva:external-link-fill" width={16} /> : null}
      sx={{ flexShrink: 0, whiteSpace: 'nowrap', ...sx }}
    >
      {target.label}
    </Button>
  );
}

NotificationActionButton.propTypes = {
  action: PropTypes.object,
  onClick: PropTypes.func,
  sx: PropTypes.object,
};
